// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-3bccedb2]{margin:0}h3.name[data-v-3bccedb2]{font-weight:normal;margin-bottom:10px}.logout[data-v-3bccedb2]{display:block;margin:20px -30px -30px;border-top:1px #EDEDED solid;padding-top:10px;padding-bottom:15px;font-weight:bold;text-decoration:none !important}\n", ""]);
// Exports
module.exports = exports;
